import { Badge } from "@/shared/ui/badge";
import { X } from "lucide-react";
import type { Tag } from "@/services/api/tags/types";

interface AssignedTagsAreaProps {
  assignedTags: Tag[];
  onRemove: (tagId: string | number) => void;
}

export function AssignedTagsArea({
  assignedTags,
  onRemove,
}: AssignedTagsAreaProps) {
  if (assignedTags.length === 0) return null;

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-ink-700">
        Currently assigned tags
      </label>
      <div className="flex flex-wrap gap-2 p-3 bg-grid-50 rounded-lg border border-grid-200">
        {assignedTags.map((tag) => (
          <Badge
            key={tag.id}
            variant="outline"
            className={`pl-2 pr-1 py-1 gap-1 flex items-center ${
              tag.color ? "" : "bg-white text-gray-800 border-gray-300"
            } ${tag.isActive ? "" : "opacity-60"}`}
            style={
              tag.color
                ? {
                    backgroundColor: `${tag.color}20`,
                    color: tag.color,
                    borderColor: `${tag.color}40`,
                  }
                : {}
            }
          >
            <span className="max-w-[150px] truncate">{tag.name}</span>
            {!tag.isActive && (
              <span className="text-[10px] text-ink-400 ml-1">(inactive)</span>
            )}
            <button
              type="button"
              onClick={() => onRemove(tag.id)}
              className="rounded-full p-0.5 transition-colors hover:bg-black/10"
              aria-label={`Remove ${tag.name ?? "tag"} tag`}
              title={`Remove ${tag.name ?? "tag"} tag`}
            >
              <X className="h-3 w-3" aria-hidden="true" />
            </button>
          </Badge>
        ))}
      </div>
    </div>
  );
}
